import {hasEsiaOAuthParams} from './esiaOAuthParams';

const LOADING_KEY = 'loadingState';

export const saveLoadingState = (isLoading: boolean, text: string) => {
  localStorage.setItem(LOADING_KEY, JSON.stringify({isLoading, text}));
};

export const loadLoadingState = (): {isLoading: boolean; text: string} => {
  const storedState = localStorage.getItem(LOADING_KEY);
  if (storedState) {
    const parsed = JSON.parse(storedState) as {isLoading?: boolean; text?: string};

    if (parsed?.isLoading && typeof window !== 'undefined') {
      if (!hasEsiaOAuthParams()) {
        clearLoadingState();
        return {isLoading: false, text: ''};
      }
    }

    return {isLoading: Boolean(parsed?.isLoading), text: parsed?.text || ''};
  }
  return {isLoading: false, text: ''};
};

export const clearLoadingState = () => {
  localStorage.removeItem(LOADING_KEY);
};
